<template>
  <aside class="dashboard-sidebar">
    <perfect-scrollbar>
      <div class="side-close d-md-none" @click="closeSidebar()"></div>
      <div class="sidebar-head" :style="{backgroundImage: `url(${require('@/assets/dashboard-logo-bg.png')})`}">
        <logo height="34px"></logo>
      </div>
      <sidebar-register v-if="!registrationComplete"></sidebar-register>
      <template v-else>
        <sidebar-nav></sidebar-nav>
      </template>
    </perfect-scrollbar>
  </aside>
</template>

<script>
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
import { mapFields } from 'vuex-map-fields'
import Logo from '@/components/header/Logo.vue'
import SidebarNav from '@/components/dashboard/SidebarNav.vue'
import SidebarRegister from '@/components/dashboard/SidebarRegister.vue'

export default {
  name: 'dashboard-sidebar',
  components: {
    PerfectScrollbar,
    Logo,
    SidebarNav,
    SidebarRegister
  },
  computed: {
    ...mapFields({
      registrationComplete: 'registration.complete'
    })
  },
  methods: {
    closeSidebar() {
      this.$store.commit('hideDashSide')
    }
  }
}
</script>

<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css"/>
